import { useEffect, useState } from 'react';
import { fetchHistory, type HistoryBucket } from '../lib/api';

export default function Timeline({ serviceId, days = 90 }: { serviceId: string; days?: number }) {
  const [buckets, setBuckets] = useState<HistoryBucket[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    fetchHistory(serviceId, days)
      .then((h) => { if (alive) setBuckets(h.buckets); })
      .catch((e) => { if (alive) setErr(String(e)); });
    return () => { alive = false; };
  }, [serviceId, days]);

  if (err) return <div className="text-xs text-muted">timeline unavailable</div>;
  if (!buckets) return <div className="h-7 w-full animate-pulse bg-purple/20 rounded" />;

  return (
    <div className="flex items-end gap-[2px]">
      {buckets.map((b) => {
        const state =
          b.total === 0 ? 'nodata' :
          b.uptime_pct >= 99.5 ? 'up' :
          b.uptime_pct >= 95 ? 'degraded' : 'down';
        const title = b.total === 0
          ? `${b.date}: no data`
          : `${b.date}: ${b.uptime_pct.toFixed(2)}% (${b.up}/${b.total}${b.incidents ? `, ${b.incidents} incident${b.incidents === 1 ? '' : 's'}` : ''})`;
        return <div key={b.date} className="timeline-block" data-state={state} title={title} />;
      })}
    </div>
  );
}
